import * as apiClient from "./axiosApiClient";
import { joinUrlWithRoute } from "../utils/urlUtils";

const baseUrl = apiClient.REACT_APP_LIST_API_BASE_URL;

export function getLists() {
    const url = joinUrlWithRoute(baseUrl, "");
    return apiClient.get(url);
}

export function postList(request) {
    const url = joinUrlWithRoute(baseUrl, "");
    return apiClient.post(url, request);
}

export function deleteList(request) {
    const url = joinUrlWithRoute(baseUrl, `/${request.listId}`);
    return apiClient.httpDelete(url, request);
}

export function updateList(request) {
    const url = joinUrlWithRoute(baseUrl, `/${request.listId}`);
    return apiClient.put(url, request);
}

/* export function syncListWithLinkedIn() {
    const url = joinUrlWithRoute(baseUrl, '/sync-lists-with-linkedin');
    return apiClient.post(url);
} */

export function syncExclusionWithLinkedIn() {
    const url = joinUrlWithRoute(baseUrl, '/sync-exclusion-accounts-with-linkedin');
    return apiClient.post(url);
}

export function syncTargetAccountsWithLinkedIn() {
    const url = joinUrlWithRoute(baseUrl, '/sync-target-accounts-with-linkedin');
    return apiClient.post(url);
}

export function syncContactsWithLinkedIn(request = {}) {
    const url = joinUrlWithRoute(baseUrl, '/sync-contacts-with-linkedin');
    return apiClient.post(url, request);
}

export function syncContactsWithGoogleAds(request = {}) {
    const url = joinUrlWithRoute(baseUrl, '/sync-contacts-with-google');
    return apiClient.post(url, request);
}

export function syncContactsWithMetaAds(request = {}) {
    const url = joinUrlWithRoute(baseUrl, '/sync-contacts-with-meta');
    return apiClient.post(url, request);
}

export function getContactsSyncJobs() {
    const url = joinUrlWithRoute(baseUrl, '/contacts-sync-jobs');
    return apiClient.get(url);
}
